import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: "",
  personAccountable: "",
  userId: "",
  isAdmin: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUser: (state, action) => {
      state.user = action.payload;
    },
    addPerson: (state, action) => {
      state.personAccountable = action.payload;
    },

    addAdminStatus: (state, action) => {
      state.isAdmin = action.payload;
    },
    addUserId: (state, action) => {
      state.userId = action.payload;
    },
    removeUser: (state) => {
      // Reset the state to its initial values
      state.user = initialState.user;
      state.userId = initialState.userId;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addUser, addUserId, removeUser, addAdminStatus, addPerson } =
  userSlice.actions;

export default userSlice.reducer;
